<script></script>
<footer class="foot bg-dark py-3">
    <p class="foot-talk text-center">Built By Chidambaranathan s</p>
    <p class="foot-talk text-center"></p>
</footer>
<style>
    .foot{
        font-family: "bsteel";
        color: #94b1be;
        word-spacing: 0.7vw;
        letter-spacing: 0.3vw;
    }
</style>